const drawerTheme = () => ({
  width: {
    // Override @unbrace/components drawer
    open: '400px',
  },
});

export default drawerTheme;
